import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import NoticeFilter from "../NoticeFilter/NoticeFilter";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import NoticeBody from "../NoticeBody/NoticeBody";
import AddNotice from "../AddNotice/AddNotice";
import NoticeDetail from "../NoticeDetail/NoticeDetail";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      search: {
        title: "",
        date: "",
      },
      isEmpty: false,
      detailStatus: false,
      detailData: [],
      column: [
        { name: "S.N." },
        { name: "Notice Title" },
        { name: "Description" },
        { name: "Created Date" },
        { name: "Actions" },
      ],
      notices: [],
    };
  }

  componentDidMount() {
    this.getNotices();
  }

  getNotices = async () => {
    try {
      const response = await Axios.get(`${url}/api/notices`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.notices.length !== 0) {
        this.setState({
          notices: response.data.notices,
          isEmpty: false,
        });
      } else {
        this.setState({
          notices: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getNotices();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.notices.filter((subject) => {
      return (
        subject.title
          .toLowerCase()
          .indexOf(this.state.search.title.toLowerCase()) !== -1 &&
        subject.createdAt
          .toLowerCase()
          .indexOf(this.state.search.date.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Notice List" refreshUrl={this.props.match.url} />

          {this.state.notices.length !== 0 && (
            <NoticeFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}
          <br />

          <Grid container spacing={3}>
            {this.state.detailStatus === false && (
              <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                <div style={{ fontSize: 20, fontWeight: "bold" }}>
                  Add New Notice
                </div>
                <AddNotice getNotices={this.getNotices} />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} xl={8} lg={8}>
              {this.state.notices.length !== 0 ? (
                <Paper>
                  <TableContainer>
                    <Table>
                      <CustomTableHead column={this.state.column} />

                      <TableBody>
                        {(rowsPerPage > 0
                          ? filtered.slice(
                              rowsPerPage * page,
                              rowsPerPage * page + rowsPerPage
                            )
                          : filtered
                        ).map((notice, index) => (
                          <NoticeBody
                            data={notice}
                            key={index}
                            index={index}
                            handleDetailStatus={this.handleDetailStatus}
                            getNotices={this.getNotices}
                          />
                        ))}
                      </TableBody>

                      <CustomTableFooter
                        count={filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handlePage}
                        onChangeRowsPerPage={this.handleRowsPerPage}
                      />
                    </Table>
                  </TableContainer>
                </Paper>
              ) : this.state.isEmpty ? (
                <CustomEmptyMessage />
              ) : (
                <CustomSiteLoader />
              )}
            </Grid>
            {this.state.detailStatus && (
              <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                <Paper>
                  <NoticeDetail
                    detailData={this.state.detailData}
                    handleCancelDetail={this.handleCancelDetail}
                  />
                </Paper>
              </Grid>
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewNotice)));
